import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';

export const createRedirectToParam = (pathname: string, search: string): string | null => {
  const currentUrlSearchParams = new URLSearchParams(search);
  currentUrlSearchParams.delete(QueryParams.REDIRECT_TO);
  currentUrlSearchParams.delete(QueryParams.AUTH_TOKEN);

  if (Array.from(currentUrlSearchParams.entries()).length === 0 && pathname === routeMap.home) {
    return null;
  }

  const searchParams = currentUrlSearchParams.toString();
  return new URLSearchParams({
    [QueryParams.REDIRECT_TO]: `${pathname}${searchParams ? `?${searchParams}` : ''}`,
  }).toString();
};
